import { API } from "../../../utils/api";

export async function postLeaseOrderAPI({ modelType, grade, periodType, insuranceType, extraProductType }) {
  return await API.post(`lease/order`, { modelType, grade, periodType, insuranceType, extraProductType })
  // return true
}